var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.17708 5.90625H1.82292C1.42027 5.90625 1.09375 5.57973 1.09375 5.17708V1.82292C1.09375 1.42027 1.42027 1.09375 1.82292 1.09375H5.17708C5.57973 1.09375 5.90625 1.42027 5.90625 1.82292V5.17708C5.90625 5.57973 5.57973 5.90625 5.17708 5.90625Z",
    stroke: "#007BFF",
    strokeWidth: 0.583333,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.09375 2.26038H5.90625",
    stroke: "#007BFF",
    strokeWidth: 0.583333,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.26034 3.79167C2.46169 3.79167 2.62492 3.62844 2.62492 3.42708C2.62492 3.22573 2.46169 3.0625 2.26034 3.0625C2.05898 3.0625 1.89575 3.22573 1.89575 3.42708C1.89575 3.62844 2.05898 3.79167 2.26034 3.79167Z",
    fill: "#007BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50008 3.79167C3.70144 3.79167 3.86466 3.62844 3.86466 3.42708C3.86466 3.22573 3.70144 3.0625 3.50008 3.0625C3.29873 3.0625 3.1355 3.22573 3.1355 3.42708C3.1355 3.62844 3.29873 3.79167 3.50008 3.79167Z",
    fill: "#007BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.26034 5.10417C2.46169 5.10417 2.62492 4.94094 2.62492 4.73958C2.62492 4.53823 2.46169 4.375 2.26034 4.375C2.05898 4.375 1.89575 4.53823 1.89575 4.73958C1.89575 4.94094 2.05898 5.10417 2.26034 5.10417Z",
    fill: "#007BFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50008 5.10417C3.70144 5.10417 3.86466 4.94094 3.86466 4.73958C3.86466 4.53823 3.70144 4.375 3.50008 4.375C3.29873 4.375 3.1355 4.53823 3.1355 4.73958C3.1355 4.94094 3.29873 5.10417 3.50008 5.10417Z",
    fill: "#007BFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73958 3.79167C4.94094 3.79167 5.10417 3.62844 5.10417 3.42708C5.10417 3.22573 4.94094 3.0625 4.73958 3.0625C4.53823 3.0625 4.375 3.22573 4.375 3.42708C4.375 3.62844 4.53823 3.79167 4.73958 3.79167Z",
    fill: "#007BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.eeab2858411ee16ad97c4a1da48f3872.svg";
export { ForwardRef as ReactComponent };